import { render, staticRenderFns } from "./GreetingBox.vue?vue&type=template&id=3c3d95cd&"
import script from "./GreetingBox.vue?vue&type=script&lang=js&"
export * from "./GreetingBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports